import type {SelectedAgent} from '@github-ui/agent-sessions-types/agent-identity'

import type {CustomModelPickerProps} from '../plugin/copilot-immersive-plugin'
import {AutoTierPicker} from './AutoTierPicker'
import {ModelPicker} from './ModelPicker'

interface ChatModelControlsProps {
  customModelPicker?: (props: CustomModelPickerProps) => React.ReactNode
  selectedAgent?: SelectedAgent
  iconOnly: boolean
  announcementElementRef?: CustomModelPickerProps['announcementElementRef']
  onModelSelectionChange?: CustomModelPickerProps['onModelSelectionChange']
  onNewThreadSelected?: () => Promise<void>
  disabled?: boolean
  isAhpEnvironment?: boolean
}

export function ChatModelControls({
  customModelPicker,
  selectedAgent,
  iconOnly,
  announcementElementRef,
  onModelSelectionChange,
  onNewThreadSelected,
  disabled,
  isAhpEnvironment,
}: ChatModelControlsProps) {
  if (!onNewThreadSelected) return null

  if (customModelPicker) {
    return customModelPicker({
      selectedAgent,
      iconOnly,
      announcementElementRef,
      onModelSelectionChange,
      isAhpEnvironment,
    })
  }

  return (
    <>
      <ModelPicker onNewThreadSelected={onNewThreadSelected} disabled={disabled} />
      <AutoTierPicker disabled={disabled} />
    </>
  )
}
